module.exports = __webpack_public_path__ + "img/i-circle-solid.1719cd0c.svg";